import React from "react";
import {Container, ContainerInner} from "../../elements/PageSection";
import {ExploreControls} from "./ExploreControls";
import PortfolioSummaryTable from "./table/PortfolioSummaryTable";
import Pagination from "./Pagination";
import styled from 'styled-components';
import {getColumns} from "./table/TableColumns";
import {TableHeadings} from "./table/TableHeadings";
import {boxShadowColour, coolBackgroundColour, darkBoxShadowColour} from "../../../style/styleConsts";
import {logAction} from "../../../logging/logEvent";
import StickyContainer from "../../../sticky/StickyContainer";
import Sticky from "../../../sticky/Sticky";

const shadowCss = "0 5px 6px 0px ";

const Background = styled.div`
    background: ${props => props.isSticky ? coolBackgroundColour : "white"};
    box-shadow: ${props => props.isSticky ? shadowCss + darkBoxShadowColour : shadowCss + boxShadowColour};
`;

const StickyHeaderContainer = styled.div`
    padding: 0 30px;
`;

const ExploreSectionContainer = styled(StickyContainer)`
    display: flex;
    flex-direction: column;
`;

const ExploreSectionContainerInner = styled(ContainerInner)`
    display: flex;
    flex-direction: column;
`;

export const ExploreSection = ({
                                   customGrouping,
                                   kpiChooser,
                                   valueChooser,
                                   canSeeAllComponents = false,
                                   backToPortfolioPage,
                                   onSecondaryGrouping,
                                   rowLinkGenerator,
                                   isLoading,
                                   totalPages,
                                   pageNumber,
                                   pageNumberToUrlFunction,
                                   ourProgrammeContext,
                                   loggingPayload,
                                   applyFilter,
                                   pageName
                               }) => {

    const {
        grouping: {
            results = []
        },
        firstGroupingName,
        secondGroupingName,
        hasIdeaLevelCalcs,
        settings: {
            currency,
            kpi,
            shareBased,
        }
    } = customGrouping;

    function onExportClickFor(type, groupingName, url) {
        return () => {
            logAction({
                type: type,
                groupingName: groupingName,
                ...ourProgrammeContext.context(),
                exportUrl: url,
                pageName: pageName
            });
        }
    }



    const exportUrl = ourProgrammeContext.exportGroupingHref(firstGroupingName);
    const controls = <ExploreControls firstGroupingName={firstGroupingName}
                                      secondGroupingName={secondGroupingName}
                                      isLoading={isLoading}
                                      onBackToOverviewClick={backToPortfolioPage}
                                      onExportClick={onExportClickFor(`GROUPING_EXPORTED`, firstGroupingName, exportUrl)}
                                      onExportDisabledClick={onExportClickFor(`DISABLED_GROUPING_EXPORT_CLICKED`, firstGroupingName, exportUrl)}
                                      showSecondaryOptions={canSeeAllComponents && hasIdeaLevelCalcs}
                                      onSecondaryGrouping={onSecondaryGrouping}
                                      ourProgrammeContext={ourProgrammeContext}
                                      exportUrl={exportUrl}
                                      applyFilter={applyFilter}/>;
    const columns = getColumns(firstGroupingName, kpiChooser);
    const headings = <TableHeadings firstGroupingName={firstGroupingName}
                                    currency={currency}
                                    kpi={kpi}
                                    columns={columns}/>;

    const stickRenderFunction = ({style, isSticky}) => {
        return <Background style={style} isSticky={isSticky}>
            <StickyHeaderContainer>
                {controls}
                {headings}
            </StickyHeaderContainer>
        </Background>
    };

    return (
        <ExploreSectionContainer>
            <Sticky render={stickRenderFunction}/>
            <Container>
                <ExploreSectionContainerInner>
                    <PortfolioSummaryTable firstGroupingName={firstGroupingName}
                                           secondGroupingName={secondGroupingName}
                                           grouping={results}
                                           kpi={kpi}
                                           valueChooser={valueChooser}
                                           currency={currency}
                                           shareBased={shareBased}
                                           rowLinkGenerator={rowLinkGenerator}
                                           columns={columns}
                    />
                    {totalPages === 1
                     ? null
                     : <Pagination totalPages={totalPages}
                                   pageNumber={pageNumber}
                                   pageNumberToUrlFunction={pageNumberToUrlFunction.bind(ourProgrammeContext)}
                                   loggingPayload={loggingPayload}/>}
                </ExploreSectionContainerInner>
            </Container>
        </ExploreSectionContainer>
    );
};

